import { render, staticRenderFns } from "./UnderlinedCollapsible.vue?vue&type=template&id=ab3b9fe0"
import script from "./UnderlinedCollapsible.vue?vue&type=script&lang=js"
export * from "./UnderlinedCollapsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports